import axiosInstance from '@/shared/api/axios';
import type {
  ApiFaqGetItem,
  ApiFaqPostBody,
  ApiFaqPutBody,
  ApiFaqsGetResponse,
} from '@/shared/types/api/faqs';

export const apiFaqsGet = async (): Promise<ApiFaqsGetResponse> => {
  const { data } = await axiosInstance.get<ApiFaqsGetResponse>('/support/faqs');
  return data;
};

export const apiFaqPost = async (body: ApiFaqPostBody): Promise<ApiFaqGetItem> => {
  const { data } = await axiosInstance.post<ApiFaqGetItem>('/support/faqs', body);
  return data;
};

export const apiFaqPut = async (id: string, body: ApiFaqPutBody): Promise<ApiFaqGetItem> => {
  const { data } = await axiosInstance.put<ApiFaqGetItem>(`/support/faqs/${id}`, body);
  return data;
};

export const apiFaqDelete = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/support/faqs/${id}`);
};
